export default "__VITE_ASSET__Bp4koet0__"